export default __webpack_public_path__ + "static/media/riddims.c79eab9a.webm";